export const formatNumber = (value) => {
    console.log(value,"issue in value")
    if (!isFinite(value)) return null;
    
    if (value < 1000) {
        // If it's a whole number, return as is, otherwise fix to 2 decimal places
        return value % 1 === 0 ? value : value?.toFixed(2);
    }

    if (value < 100000) {
        return (value / 1e3)?.toFixed(2) + 'K'; // Up to 99.99K
    } else {
        return (value / 1e6)?.toFixed(2) + 'M'; // 100,000+ becomes M
    }
};
